/**
 * Человеческие подписи ролей и типов чат-комнат.
 *
 * Единственный источник названий ролей — RBAC_ROLES: копия словаря в чате
 * разошлась с ним и не знала партнёрских ролей, поэтому у менеджеров по
 * партнёрам метка выводилась как сырое `partner_manager` (планёрка 11.08.2026).
 */

import { RBAC_ROLES } from '../components/rbac/constants'

/** Роль пользователя → русское название. Неизвестная роль возвращается как есть. */
export function roleLabel(role) {
    if (!role) return ''
    return RBAC_ROLES[role]?.label || role
}

/** Роль ВНУТРИ комнаты: показываем только модераторов, рядовой участник метки не носит. */
export function roomRoleLabel(chatRole) {
    if (chatRole === 'owner') return 'Владелец чата'
    if (chatRole === 'admin') return 'Модератор'
    return ''
}

/** Тип комнаты → русское название для панели «О чате». */
export function roomTypeLabel(type) {
    return {
        direct: 'Личная переписка',
        group: 'Группа',
        channel: 'Канал',
        announcement: 'Объявления',
        telegram: 'Telegram',
    }[type] || type || ''
}
